<template>
  <van-pull-refresh v-model="refreshing" @refresh="refresh">
    <!--    <div slot="loading" />-->
    <!--    v-show="!showSkeleton && !showEmpty "-->
    <slot v-if="showEmpty" name="empty" />
    <van-list
      v-else
      ref="listRef"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <slot v-bind="this" />
    </van-list>
    <!--    TODO 完善骨架屏-->
    <!--    <slot v-show="showEmpty" name="empty" />-->
    <!--    <slot v-show="showSkeleton && $scopedSlots.skeleton" />-->
    <!--    <van-skeleton-->
    <!--      v-for="i in 3"-->
    <!--      v-show="showSkeleton && !$scopedSlots.skeleton"-->
    <!--      :key="i"-->
    <!--      :row="3"-->
    <!--      style="margin-bottom: 12px"-->
    <!--    />-->
  </van-pull-refresh>
</template>

<script>
export default {
  name: 'NxList',
  props: {
    value: {
      type: Array,
      required: true,
    },
    request: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      pagination: {
        pageIndex: 0,
        pageSize: 10,
        totalCount: 0,
        pageTotal: 0,
      },
    };
  },
  computed: {
    data: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      },
    },
    showEmpty() {
      return this.error || (this.finished && this.pagination.totalCount === 0 && (!this.loading));
    },
    showSkeleton() {
      return this.loading && this.pagination.pageIndex === 0;
    },
  },
  methods: {
    async handleRequest(params) {
      this.$emit('before-request', this.pagination);
      const { dataList, list, page, pageNum, pageSize: _pageSize, total, pages } = await this.request(params).finally(() => {
        this.$emit('after-request', this.pagination);
      });
      const { pageTotal, totalCount, pageIndex, pageSize } = page || {};
      this.pagination.pageIndex = pageIndex ?? pageNum;
      this.pagination.pageSize = pageSize ?? _pageSize;
      this.pagination.totalCount = totalCount ?? total;
      this.pagination.pageTotal = pageTotal ?? pages;
      this.$emit('request-success', this.pagination);
      if (this.pagination.pageIndex === this.pagination.pageTotal || this.pagination.pageTotal === 0) {
        this.finished = true;
        this.$emit('finished');
      }
      return dataList || list;
    },
    async onLoad() {
      this.error = false;
      const pageParams = {
        pageIndex: this.pagination.pageIndex + 1,
        pageSize: this.pagination.pageSize,
      };

      try {
        const data = await this.handleRequest({ ...pageParams });
        this.data = pageParams.pageIndex > 1 ? this.data.concat(data || []) : data;
      }
      catch (e) {
        this.error = true;
        // this.loading = false;
        // this.refreshing = false;
        console.error(e);
        throw e;
      }
      this.loading = false;
      this.refreshing = false;
    },
    refresh() {
      // 清空列表数据
      this.finished = false;
      this.pagination.pageIndex = 0;
      this.data = [];

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
};
</script>

<style scoped lang="scss">

</style>
